import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "wrapper my-4 py-5 pb-10 md:pb-0" }
const _hoisted_2 = { class: "rounded my-2 lg:rounded-2xl lg:shadow-xs drop-shadow-sm" }
const _hoisted_3 = { class: "w-full flex items-center" }
const _hoisted_4 = { class: "transition duration-150 text-primary-400 shadow -mt-16 ml-8 text-center opacity-0 group-hover:opacity-100 absolute" }
const _hoisted_5 = { class: "pb-5 my-4 mt-5" }
const _hoisted_6 = { class: "appFont text-2xl" }
const _hoisted_7 = ["for"]
const _hoisted_8 = {
  key: 2,
  class: "text-red-400"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileImageLazy = _resolveComponent("ProfileImageLazy")!
  const _component_Pencil = _resolveComponent("Pencil")!
  const _component_Tippy = _resolveComponent("Tippy")!
  const _component_Separator = _resolveComponent("Separator")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_BuyMoreUniqueContainer = _resolveComponent("BuyMoreUniqueContainer")!
  const _component_PremiumSettings = _resolveComponent("PremiumSettings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_component_Tippy, {
          content: _ctx.$t('Update profile picture'),
          class: "m-auto"
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "group",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/me/profile_image')))
            }, [
              _createVNode(_component_ProfileImageLazy, {
                "premium-cube": _ctx.premiumCubeImage,
                user: _ctx.user,
                "custom-class": "group-hover:opacity-50 w-24 h-24"
              }, null, 8, ["premium-cube", "user"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Pencil, { class: "fa-2x" })
              ])
            ])
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("form", {
          class: "max-w-sm mx-auto",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createVNode(_component_Separator),
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('General')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.fields, (value, field_name) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mt-3",
              key: field_name
            }, [
              _createElementVNode("label", { for: field_name }, _toDisplayString(field_name.humanWords()), 9, _hoisted_7),
              (!Object.keys(_ctx.field_casts).includes(field_name))
                ? (_openBlock(), _createBlock(_component_Input, {
                    key: 0,
                    id: field_name,
                    placeholder: field_name.humanWords(),
                    modelValue: _ctx.form.fields[field_name],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.form.fields[field_name]) = $event),
                    modelModifiers: { lazy: true }
                  }, null, 8, ["id", "placeholder", "modelValue", "onUpdate:modelValue"]))
                : (_ctx.field_casts[field_name] == 'textarea')
                  ? (_openBlock(), _createBlock(_component_Textarea, {
                      key: 1,
                      rows: "3",
                      modelValue: _ctx.form.fields[field_name],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.form.fields[field_name]) = $event),
                      modelModifiers: { lazy: true },
                      placeholder: field_name.humanWords()
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                  : _createCommentVNode("", true),
              (Object.keys(_ctx.errors).includes(field_name))
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors[field_name], (error) => {
                      return (_openBlock(), _createElementBlock("span", { key: error }, [
                        _createTextVNode(_toDisplayString(error), 1),
                        _hoisted_9
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createVNode(_component_Button, {
            class: "mt-3",
            onClick: _ctx.submit,
            type: "submit"
          }, {
            default: _withCtx(() => [
              (!_ctx.processing)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('Save')), 1))
                : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_LinkButton, {
            class: "w-full",
            to: "/me/bio-links"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                "gray-theme": true,
                class: "mt-3",
                type: "button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Change Bio Links')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Separator),
          (!_ctx.user.is_premium)
            ? (_openBlock(), _createBlock(_component_BuyMoreUniqueContainer, { key: 0 }))
            : _createCommentVNode("", true)
        ], 32),
        (_ctx.user.is_premium)
          ? (_openBlock(), _createBlock(_component_PremiumSettings, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}